export default __webpack_public_path__ + "static/media/ExpoElectrica.1c3f20eb.png";